import http from "./httpService";

class LessonLibraryService {
  async getLessonBySlug(slug) {
    return http.get(`/lessons/slug/${slug}`);
  }

  async likeLesson(lessonId) {
    return http.post(`/lessons/${lessonId}/like`);
  }
  async getLessonContentComments(lessonId) {
    return http.get(
      `/lesson_custom_comments?lesson_id=${lessonId}&limit=1000&sort_by=created_at&order=asc`
    );
  }

  async createContentComment(data) {
    return http.post("/lesson_custom_comments", data);
  }

  async updateLessonContentComment(commentId, data) {
    return http.put(`/lesson_custom_comments/${commentId}`, data);
  }

  async deleteLessonContentComment(commentId) {
    return http.delete(`/lesson_custom_comments/${commentId}`);
  }

  async likeLessonContentComment(commentId) {
    return http.post(`/lesson_custom_comments/${commentId}/like`);
  }

  async getLessonComments(lessonId) {
    return http.get(
      `/lesson_comments?lesson_id=${lessonId}&limit=10&sort_by=created_at&order=asc`
    );
  }

  async createLessonComment(data) {
    return http.post("/lesson_comments", data);
  }

  async updateLessonComment(commentId, data) {
    return http.put(`/lesson_comments/${commentId}`, data);
  }

  async deleteLessonComment(commentId) {
    return http.delete(`/lesson_comments/${commentId}`);
  }

  async likeLessonComment(commentId) {
    return http.post(`/lesson_comments/${commentId}/like`);
  }
}

export default new LessonLibraryService();
